import validate from "/builds/marketing/website-2.0/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45utms_45global from "/builds/marketing/website-2.0/middleware/01.utms.global.ts";
import _02_45disclaimers_45global from "/builds/marketing/website-2.0/middleware/02.disclaimers.global.ts";
import manifest_45route_45rule from "/builds/marketing/website-2.0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45utms_45global,
  _02_45disclaimers_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}